import React, { useState } from "react";
import ReportPageShell from "../components/ReportPageShell";
import MetricGrid from "../components/MetricGrid";
import MethodologyPanel from "../components/MethodologyPanel";
import StatCard from "../components/StatCard";
import { useReportQuery } from "../shared/useReportQuery";
import { defaultFilters, toQueryParams } from "../shared/filters";
import { formatMetric, METRIC_LABELS } from "../shared/format";
import { MetricKey } from "../api/types";

// Order of the headline metrics in the stat-card strip. Net Sales is emphasized —
// it's the corrected number the new engine exists to get right.
const SUMMARY_METRICS: MetricKey[] = [
  "NetSales",
  "Gross",
  "Tax",
  "Discount",
  "Refunds",
  "Tip",
  "Surcharge",
  "OrderCount",
  "TransactionCount",
];

const TOOLTIP =
  "Per-event financial summary from the NEW unified reporting engine. " +
  "Net Sales = Σ(item subtotal − item discount) − order discounts − refunds, real-money only " +
  "(token/promo-balance funded amounts excluded). Gross = item subtotal + tax only — tips and " +
  "the service fee are reported separately and are never part of sales.";

// Parallel to the OLD Financial Report / Event Summary. EventSummary is a Composite
// report: one row per event carrying the full headline metric set.
export default function EventSummaryReport() {
  const [filters, setFilters] = useState(defaultFilters);
  const state = useReportQuery(toQueryParams("EventSummary", filters));

  return (
    <ReportPageShell
      title="Financial Summary by Event"
      tooltipText={TOOLTIP}
      filters={filters}
      onFiltersChange={setFilters}
      state={state}
    >
      {(data) => (
        <>
          <div className="mb-3 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
            {SUMMARY_METRICS.filter((m) => data.metrics.includes(m)).map((m) => (
              <StatCard
                key={m}
                label={METRIC_LABELS[m]}
                value={formatMetric(m, data.totals[m])}
                emphasis={m === "NetSales"}
              />
            ))}
          </div>
          <MethodologyPanel metrics={data.metrics} window={data.window} />
          <MetricGrid data={data} keyColumnHeader="Event" exportName="FinancialSummaryByEvent" />
        </>
      )}
    </ReportPageShell>
  );
}
